import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TableWrapper = styled.div`
  width: 730px;
  overflow-x: auto;
`;

const tableColumns = [
  {
    columns: [
      {
        Header: 'Chapter Name',
        accessor: 'name',
        width: 300,
      },
      {
        Header: 'Number of goals',
        accessor: 'goals',
        width: 200,
      },
      {
        Header: 'Number of worksheets',
        accessor: 'worksheets',
        width: 200,
      },
    ],
  },
];

class ChapterTable extends PureComponent {
  render() {
    const { chaptersData } = this.props;
    return (
      <TableWrapper>
        <ReactTable
          data={chaptersData}
          className="-striped -highlight"
          manual
          filterable={false}
          sortable={false}
          resizable={false}
          columns={tableColumns}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    );
  }
}

ChapterTable.propTypes = {
  chaptersData: PropTypes.arrayOf(PropTypes.shape({})),
};

ChapterTable.defaultProps = {
  chaptersData: null,
};

export default ChapterTable;
